export default __webpack_public_path__ + "static/media/three-dots-vertical.23132274.svg";